import {
  axiosGet,
  axiosPost,
  axiosPut,
  axiosPatch,
} from '../plugins/axios.plugins';
import { getDataApiVersion } from '../utils/helpers';

const API_ENDPOINTS = {
  APP_DATA_BASEURL: `${process.env.VUE_APP_DATA_API}`,
  DATA_API_BASE_URL: `${process.env.VUE_APP_DATA_API_BASE_URL}`,
};

export const updateSchemaField = (query, payload) => {
  return axiosPut(
    `${API_ENDPOINTS.APP_DATA_BASEURL}/user-tables/${query.tableName}/table-schema/${query.fieldName}`,
    payload
  );
};
export const createDatabaseTable = (payload) => {
  return axiosPost(`${API_ENDPOINTS.APP_DATA_BASEURL}/user-tables`, payload);
};
export const getTableColumns = (payload) => {
  return axiosPost(
    `${API_ENDPOINTS.APP_DATA_BASEURL}/list-table-columns`,
    payload
  );
};
export const getCustomDatabaseItems = (
  tableName,
  params = '',
  customNotFoundRedirect = false
) => {
  return axiosGet(
    encodeURI(
      `${API_ENDPOINTS.DATA_API_BASE_URL}/${getDataApiVersion(
        tableName
      )}/user-tables/${tableName}/items${params}`
    ),
    customNotFoundRedirect ? { customNotFoundRedirect } : {}
  );
};
export const getCustomDatabaseItem = (
  tableName,
  itemID,
  customNotFoundRedirect = false
) => {
  return axiosGet(
    `${API_ENDPOINTS.DATA_API_BASE_URL}/${getDataApiVersion(
      tableName
    )}/user-tables/${tableName}/items/${itemID}`,
    customNotFoundRedirect ? { customNotFoundRedirect } : {}
  );
};

// Update below URL once API to download file is ready
export const downloadFile = (tableName, fileName) => {
  return axiosGet(
    encodeURI(
      `${API_ENDPOINTS.APP_DATA_BASEURL}/user-tables/${tableName}/files/${fileName}`
    ),
    { responseType: 'blob' }
  );
};

export const updateOneItemField = (tableName, itemID, key, payload) => {
  return axiosPatch(
    encodeURI(
      `${API_ENDPOINTS.APP_DATA_BASEURL}/user-tables/${tableName}/items/${itemID}/${key}`
    ),
    payload
  );
};
